export default "__VITE_ASSET__CJlcVVwA__"